import { Injectable } from '@angular/core';
import { Cache } from '../model/cache';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache: any = {};
  constructor() { }

  public set(key: string, value: any, expiration: Date = null): void {
    const cache = new Cache();
    cache.value = value;
    cache.expire = expiration;

    this.cache[key] = cache;
  }

  public get(key: string): any | null {
    const cache = this.cache[key];
    if (cache) {
      const now = Date.now();
      if (cache.expire === null) {
        return cache.value;
      } else if (cache.expire.getTime() >= now) {
        return cache.value;
      } else {
        delete this.cache[key];
        return null;
      }
    } else {
      return null;
    }
  }
}
